import { render } from "./SellsAlert.vue?vue&type=template&id=0751dce0&scoped=true"
import script from "./SellsAlert.vue?vue&type=script&lang=js"
export * from "./SellsAlert.vue?vue&type=script&lang=js"

import "./SellsAlert.vue?vue&type=style&index=0&id=0751dce0&scoped=true&lang=css"

import exportComponent from "/Users/renzocappelli/Lavoro/bikinilovers/newPosBKL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0751dce0"]])

export default __exports__